import { CLOSETPaymentCurrency, CLOSETPaymentMethod } from '../../../groups';
import { BillDetailType, BillType } from 'types/plansales/billing';

// /closet/groups api 전용
export enum CLOSETGroupsPlanType {
  FREE = 1,
  STANDARD = 2,
  STANDARD_TRIAL = 3,
  PREMIUM = 4,
  PREMIUM_TRIAL = 5,
  ACADEMIC = 6,
  ADVANCED = 7,
}

export interface GetCLOSETGroupsParams {
  startDate: string;
  endDate: string;
  planTypes: CLOSETGroupsPlanType[];
  paymentMethods: CLOSETPaymentMethod[];
  keyword?: string;
  managerEmail?: string;
  pageSize: number;
  pageNo: number;
}

export interface CLOSETGroupItem {
  groupId: string;
  groupAdminEmail: string;
  planType: CLOSETGroupsPlanType;
  paymentMethod: CLOSETPaymentMethod;
  subscriptionTerm: { startDate: string; endDate: string };
  measurementPeriodTerm: { startDate: string; endDate: string };
  registeredDate: string;
  isNearSubscriptionExpiry: boolean;
}

export interface GetCLOSETGroupsListResponse {
  pageSize: number;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  items: CLOSETGroupItem[];
}

export interface CLOSETGroupsManager {
  id: number;
  userId: number;
  email: string;
}

export type GetCLOSETGroupsManagersResponse = CLOSETGroupsManager[];

export interface APICLOSETGroupsDefaultParams {
  groupId: string;
}

export interface GetCLOSETGroupsMembersSummaryResponse {
  groupAdminCount: number;
  adminCount: number;
  collaboratorCount: number;
  editorCount: number;
  viewerCount: number;
  groupOperatorCount: number;
}

export interface GetCLOSETGroupInfoResponse {
  groupId: string;
  groupName: string;
  groupAdminEmail: string;
  planType: CLOSETGroupsPlanType;
  paymentMethod: CLOSETPaymentMethod;
  paymentCurrency: CLOSETPaymentCurrency;
  managers: GetCLOSETGroupsManagersResponse;
}

export interface PostCLOSETGroupsManagersParams extends APICLOSETGroupsDefaultParams {
  userId: number;
}

export interface DeleteCLOSETGroupsManagersParams extends APICLOSETGroupsDefaultParams {
  userId: number;
}

export type PostCLOSETGroupsManagersResponse = CLOSETGroupsManager;

export interface GetCLOSETGroupsUsageItem {
  maximumUsage: number | null;
  currentUsage: number;
}

export interface GetCLOSETGroupsUsageResponse {
  plan: CLOSETGroupsPlanType;
  render: GetCLOSETGroupsUsageItem;
  workroom: GetCLOSETGroupsUsageItem;
  file: GetCLOSETGroupsUsageItem;
  user: GetCLOSETGroupsUsageItem & { supportUsage: number };
  company: GetCLOSETGroupsUsageItem;
  embed: GetCLOSETGroupsUsageItem;
  apiCall: GetCLOSETGroupsUsageItem;
}

export interface GetCLOSETGroupsSubscriptionHistoryParams extends APICLOSETGroupsDefaultParams {
  pageSize?: number;
  pageNo?: number;
}

export interface GetCLOSETGroupsSubscriptionHistoryItem {
  plan: string;
  paymentMethod: string;
  registeredDate: string;
  subscriptionStartDate: string;
  subscriptionEndDate: string;
  measurementStartDate: string;
  measurementEndDate: string;
  registeredByEmail: string;
  status: string;
}

export interface GetCLOSETGroupsSubscriptionHistoryResponse {
  pageSize: number;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  items: GetCLOSETGroupsSubscriptionHistoryItem[];
}

export interface GetCLOSETGroupsBillingHistoryParams extends APICLOSETGroupsDefaultParams {
  pageSize?: number;
  pageNo?: number;
}

export interface GetCLOSETGroupsBillingHistoryItemDetails {
  amount: number;
  quantity: number;
  type: BillDetailType;
  startDate: string;
  endDate: string;
}

export interface GetCLOSETGroupsBillingHistoryItem {
  type: BillType;
  plan: CLOSETGroupsPlanType;
  previousPlan: CLOSETGroupsPlanType;
  date: string;
  registeredDate: string;
  amount: number;
  balance: number;
  invoiceId: string;
  registeredById: number;
  registeredByEmail: string;
  details: GetCLOSETGroupsBillingHistoryItemDetails[];
}

export interface GetCLOSETGroupsBillingHistoryResponse {
  pageSize: number;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  items: GetCLOSETGroupsBillingHistoryItem[];
}

export interface GetCLOSETGroupsCommentsParams {
  groupId: string;
  pageSize?: number;
  pageNo?: number;
}

export interface PostCLOSETGroupsCommentsParams {
  groupId: string;
  description: string;
}

export interface DeleteCLOSETGroupsCommentsParams {
  groupId: string;
  commentId: number;
}

export interface PutCLOSETGroupsCommentsParams {
  groupId: string;
  commentId: number;
  description: string;
}

export interface GetCLOSETGroupsCommentItem {
  id: number;
  no: number;
  description: string;
  postedDateUtc: string;
  updatedDate: string;
  operator: string;
  postedDateKstTime: string;
}

export interface GetCLOSETGroupsCommentsResponse {
  pageSize: number;
  currentPage: number;
  totalItems: number;
  totalPages: number;
  items: GetCLOSETGroupsCommentItem[];
}
